export default __webpack_public_path__ + "static/Tribal-cb0256cb4abab77bc8cffe4cf7130dc1.png";